import { Injectable } from '@angular/core';
import { SweetAlertOptions } from 'sweetalert2';
import Swal from 'sweetalert2';
import { ALERTS } from '../common';
// MODELS

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor() {}

  ShowBigCenteredAlert(message: string, alertId: number) {
    this.BigCenteredAlert(message, ALERTS[alertId].toString());
  }

  ShowSmallCornerAlert(message: string, alertId: number) {
    this.SmallCornerAlert(message, ALERTS[alertId].toString());
  }

  ConfirmationAlert(titulo: string, msg: string, confirmButtonText: string) {
    let settings: SweetAlertOptions = {
      title: titulo,
      text: msg,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#007bff',
      cancelButtonColor: '#dc3545',
      confirmButtonText: confirmButtonText,
      cancelButtonText: 'Cancelar',
    };

    return Swal.fire(settings).then((result) => {
      return result.isConfirmed;
    });
  }

  private SmallCornerAlert(msn: any, tipo: any) {
    const toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
    });

    toast.fire({
      icon: tipo,
      text: msn,
    });
  }

  private BigCenteredAlert(msn: any, tipo: any) {
    Swal.fire({
      icon: tipo,
      text: msn
    });
  }
}
